export class ClassNote {




   static async loadPupilNotesByPupil(dm, pupilId) {

      const user = dm.getUserSelf();
      const response = await dm.sinRequest({ action: 'classnote-get-items', pupilId, types: ['pupilNote', 'smartphoneViolation']});

      return [
         ...response.data.filter(item => item.creatorId !== user.id),
         ...(await db.classNotes.filter(item => item.pupilId === pupilId).toArray())
      ];

      /*
      return (await db.classNotes
         .filter(item => item.classes.includes(classId) &&
            (item.dateFrom >= from && item.dateFrom <= to) || (item.dateTo >= from && item.dateTo <= to)
         ).toArray());


         data.classRegister = data.classRegister.filter(item => item.creatorId !== this.user.id)
      */




   }
}